import { AreaDetail, AreaId } from './types'
import client from '../../client'

export * from './types'

export const get = async (id: AreaId) => {
  const data: AreaDetail = await client.get(`/user/areas/${id}`)
  return data
}
